export const SEGMENTATION_MODELS = {
    MediapipeSelfie: 'selfie',
    DeepLabV3: 'deeplabV3',
};
